let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eb8gQ")).then(() => parcelRequire('dBE7n'));